import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { VoiceButton } from "@/components/quantum/TeachingCards";

// Ariel's reflection on this practice's before/after body check and the path so far. Saved to the journal on the server.
export default function PracticeReflection({ checkId, testId = "practice-reflection" }) {
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const load = useCallback(() => {
    setError("");
    api.post(`/body/checks/${checkId}/reflection`)
      .then(({ data }) => setText(data?.text ?? ""))
      .catch((e) => setError(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Ariel's reflection is still arriving."));
  }, [checkId]);
  useEffect(() => {
    if (checkId) load();
  }, [checkId, load]);
  if (!checkId) return null;
  return (
    <section data-testid={testId} className="mt-6 border-l-2 border-[#D9B47A]/60 bg-[#140D0A] p-5 text-left">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="font-tt-mono text-[11px] uppercase tracking-[0.2em] text-[#D9B47A]">Ariel reflects on your practice</p>
        {text && <VoiceButton text={text} testId={`${testId}-voice`} />}
      </div>
      {text ? (
        <p data-testid={`${testId}-text`} className="mt-3 whitespace-pre-line font-display italic text-[18px] leading-relaxed text-[#F2E8DF]">{text}</p>
      ) : error ? (
        <div className="mt-3">
          <p data-testid={`${testId}-error`} className="text-[14px] text-[#CFC2B6]">{error}</p>
          <button data-testid={`${testId}-retry`} onClick={load} className="mt-3 rounded-full border border-[#D9B47A]/50 px-5 py-2 text-[13px] text-[#D9B47A] hover:bg-[#D9B47A] hover:text-[#0A0706] transition-colors">Try again</button>
        </div>
      ) : (
        <p data-testid={`${testId}-loading`} className="mt-3 animate-pulse font-display italic text-[17px] text-[#CFC2B6]">Ariel is feeling into what shifted…</p>
      )}
      {text && <p className="mt-3 text-[12px] text-[#A8998C]">Kept in your journal.</p>}
    </section>
  );
}
